// Utility to normalize Quill HTML by removing redundant blank paragraphs and <br> tags
// This prevents extra gaps when rendering with dangerouslySetInnerHTML
export function normalizeQuill(html: string): string {
  if (!html) return '';

  // Remove leading and trailing whitespace
  let normalized = html.trim();

  // Replace multiple consecutive <br> tags with a single one
  normalized = normalized.replace(/(<br\s*\/?>\s*){2,}/gi, '<br />');

  // Remove empty paragraphs (<p><br></p> or <p></p>)
  normalized = normalized.replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '');
  normalized = normalized.replace(/<p>\s*<\/p>/gi, '');

  // Collapse multiple empty paragraphs into one (if any remain)
  normalized = normalized.replace(/(<p>\s*<br\s*\/?>\s*<\/p>\s*)+/gi, '<p><br /></p>');

  // Remove leading and trailing empty paragraphs
  normalized = normalized.replace(/^(<p>\s*<br\s*\/?>\s*<\/p>\s*)+/, '');
  normalized = normalized.replace(/(<p>\s*<br\s*\/?>\s*<\/p>\s*)+$/, '');

  return normalized;
}
